function asm_populate_states (states) {
	var states_array = JSON.parse(states);

	var default_state = document.getElementById('asm-shipping-state').getAttribute('data-default');
	var states_tag = document.getElementById('asm-shipping-state');
	var states_length = states_tag.options.length;
	for (i = states_length - 1; i >= 0; i--) {
		states_tag.options[i] = null;
	}

	if (states_array.length > 0) {
		for (i = 0; i < states_array.length; i++) {
			var option = document.createElement("option");
			option.text = states_array[i][0];
			states_tag.add(option);
		}

		if (default_state != '')
			document.getElementById('asm-shipping-state').value = default_state;

		document.getElementById('asm-shipping-state-holder').style.display = 'block';
	} else {
		document.getElementById('asm-shipping-state-holder').style.display = 'none';
	}
}

function asm_parse_methods (shipping_rates) {
	var shipping_methods = JSON.parse(shipping_rates);

	var results = '';

	if ((shipping_methods.shipping_rates) && (shipping_methods.shipping_rates.length > 0)) {
		for (i = 0; i < shipping_methods.shipping_rates.length; i++) {
			if ((shipping_methods.shipping_rates[i].name != '') && (shipping_methods.shipping_rates[i].price != '')) {
				results = results + '<div class="asm-shipping-method">';

              	if (shipping_methods.shipping_rates[i].price == '0.00')
					results = results + '	<div class="asm-method-rate free-ship">FREE</div>';
    			else            
					results = results + '	<div class="asm-method-rate">'+ global_setting_currency.replace ('{{amount}}', shipping_methods.shipping_rates[i].price) +'</div>';

				results = results + '	<div class="asm-method-name">'+ shipping_methods.shipping_rates[i].name +'</div>';
				results = results + '	<div class="clear-both"></div>';

              	if (shipping_methods.shipping_rates[i].description != null) {
					results = results + '	<div class="asm-method-description">'+ shipping_methods.shipping_rates[i].description +'</div>';
					results = results + '	<div class="clear-both"></div>';
              	}

				results = results + '</div>';
			}
		}
	} else {
		results = results + '<div class="asm-shipping-method">';

      	if (global_setting_error != '')
      		results = results + global_setting_error;
		else
			results = results + '	There are no shipping methods available to your destination.<br />Please make sure you selected the proper country, state/province, and zip/postal code.';
        
		results = results + '</div>';
	}

	document.getElementById('asm-results').innerHTML = results;
}

function asm_calc_shipping () {
	document.getElementById('asm-shipping-calc-button-loader').style.display = 'block';
	document.getElementById('asm-results').innerHTML = '';

	var shipping_rates;
	var xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function() {
	    if (xhr.readyState === 4) {
	        shipping_rates = xhr.response;
			asm_parse_methods (shipping_rates);
			document.getElementById('asm-shipping-calc-button-loader').style.display = 'none';
		}
	};
	xhr.open('GET', '/cart/shipping_rates.json?shipping_address[zip]='+ document.getElementById('asm-shipping-zip').value +'&shipping_address[country]='+ document.getElementById('asm-shipping-country').value +'&shipping_address[province]='+ document.getElementById('asm-shipping-state').value, true);
	xhr.send()
}

function asm_activate_enter (evt) {
	evt = (evt) ? evt : event;
	var charCode = (evt.charCode) ? evt.charCode :
		((evt.which) ? evt.which : evt.keyCode);
	if (charCode == 13) {
		asm_calc_shipping();
		return false;
	} else {
		return true;
	}
}

function asm_calc_init () {
	var default_country = document.getElementById('asm-shipping-country').getAttribute('data-default');
	if (default_country != '')
		document.getElementById('asm-shipping-country').value = default_country;

  	document.getElementById('asm-shipping-country').onchange();
}

var load_counter = 0;
var tmp_timeout;
var global_setting_currency;
var global_setting_error;